import {
  createIntroduction,
  respondToIntroduction,
  requestCalendarAvailability,
  getInteractionPermission,
  bookMeeting,
  requestMeetingChange,
  respondMeetingChange,
  cancelMeeting,
} from '../integrations/backend';

export const introductionService = {
  send: (companyId, payload) => createIntroduction(companyId, payload),
  respond: (companyId, introId, action, extra = {}) => respondToIntroduction(companyId, { introId, action, ...extra }),
  requestAvailability: (companyId, payload) => requestCalendarAvailability(companyId, payload),
  permission: (companyId, targetUserId) => getInteractionPermission(companyId, { targetUserId }),
};

export const meetingWorkflowService = {
  book: (companyId, payload) => bookMeeting(companyId, payload),
  requestChange: (companyId, payload) => requestMeetingChange(companyId, payload),
  respondChange: (companyId, payload) => respondMeetingChange(companyId, payload),
  cancel: (companyId, meetingId, reason = '') => cancelMeeting(companyId, { meetingId, reason }),
};

export default { introductionService, meetingWorkflowService };
